










import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class Abount extends Vue {
  public items = new Array();
  public params: Common.MatterQuery = new Common.MatterQuery();
  public sortOptions: any = [{ value: 'id', text: '案件名(ID)' }, { value: 'project', text: 'プロジェクト' }, { value: 'state', text: '状態' }];
  public badgeStyles: any = ['olive', 'orange', 'blue', 'maroon', 'navy', 'teal', 'purple', 'gray'];
  public value: Date = null;
  public category :any = null;
  public project :any = null;
  public created() {
    this.items.push('yota@code-x.co.jp');
    const q = new Common.MatterQuery();
    this.$api.execute(q).then(data => {
      this.items =data.result;
    });
  }
  public onWorkflow(index:number){

  }

  public onExec(){
    const destination = (this.$refs.autoComplete as any) as Components.IControl;
    const body = (this.$refs.textbox as any) as Components.IControl;

    var validated1 = destination.validator.validate();
    var validated2 = body.validator.validate();
  }
}
